import React, { useEffect, useMemo, useState } from 'react';
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiFetch, extractErrorMessage } from '../../Services/authClient';
import { FiAward, FiHome, FiMessageCircle, FiUser, FiUsers } from 'react-icons/fi';

const AuthenticatedApp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [profile, setProfile] = useState(null);
  const [status, setStatus] = useState('loading');

  const navItems = useMemo(() => ([
    { path: '/app', label: t('app.nav.home', 'Home'), icon: <FiHome /> },
    { path: '/app/chat', label: t('app.nav.chat', 'Chat'), icon: <FiMessageCircle /> },
    { path: '/app/rivalry', label: t('app.nav.rivalry', 'Rivalry'), icon: <FiAward /> },
    { path: '/app/teams', label: t('app.nav.teams', 'Teams'), icon: <FiUsers /> },
    { path: '/app/profile', label: t('app.nav.profile', 'Profile'), icon: <FiUser /> },
  ]), [t]);

  useEffect(() => {
    const token = localStorage.getItem('meanc_access');
    if (!token) {
      navigate('/access-lab', { replace: true, state: { from: location.pathname } });
      return;
    }

    apiFetch('/meanc/users/me/profile-show/')
      .then((data) => {
        setProfile(data);
        setStatus('loaded');
      })
      .catch((error) => {
        console.error('Profile fetch failed', error);
        setStatus('error');
      });
  }, [location.pathname, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('meanc_access');
    localStorage.removeItem('meanc_refresh');
    navigate('/access-lab', { replace: true });
  };

  return (
    <div className="app-shell">
      <header className="app-shell__topbar">
        <div>
          <Link to="/" className="app-shell__logo">Meanc</Link>
          <span className="app-shell__section">{t('app.shell.section', 'Secure Arena')}</span>
        </div>
        <div className="app-shell__profile">
          {status === 'loading' && <span>{t('app.status.syncing', 'Syncing session…')}</span>}
          {status === 'error' && <span>{t('app.status.expired', 'Session expired')}</span>}
          {profile && (
            <>
              <span>{profile.first_name || profile.username}</span>
              <button type="button" onClick={handleLogout}>{t('app.shell.logout', 'Logout')}</button>
            </>
          )}
        </div>
      </header>
      <div className="app-shell__body">
        <aside className="app-shell__nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/app'}
              className={({ isActive }) => (isActive ? 'is-active' : '')}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
        </aside>
        <main className="app-shell__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AuthenticatedApp;
